// // ç// // import React from "react";
// // // // import { Link } from "react-router-dom";

// // // // const CorporateSidebar = () => {
// // // //   return (
// // // //    <div className="space-y-3">
// // // //       <Link to="/kurumsal" className="text-blue-700 hover:underline block">Hakkımızda</Link>
// // // //       <Link to="/kurumsal/misyonumuz" className="text-blue-700 hover:underline block">Misyonumuz</Link>
// // // //       <Link to="/kurumsal/vizyonumuz" className="text-blue-700 hover:underline block">Vizyonumuz</Link>
// // // //     </div>
// // // //   );
// // // // };

// // // // export default CorporateSidebar;
// // // import React from "react";
// // // import { Link, useLocation } from "react-router-dom";

// // // const CorporateSidebar = () => {
// // //   const location = useLocation(); // Aktif URL'yi almak için

// // //   const links = [
// // //     { path: "/kurumsal", label: "Hakkımızda" },
// // //     { path: "/kurumsal/misyonumuz", label: "Misyonumuz" },
// // //     { path: "/kurumsal/vizyonumuz", label: "Vizyonumuz" },
// // //   ];

// // //   return (
// // //     <div className="space-y-3">
// // //       {links.map((link) => (
// // //         <Link
// // //           key={link.path}
// // //           to={link.path}
// // //           className={`block hover:underline ${
// // //             location.pathname === link.path ? "font-bold text-blue-900" : "text-blue-700"
// // //           }`}
// // //         >
// // //           {link.label}
// // //         </Link>
// // //       ))}
// // //     </div>
// // //   );
// // // };

// // // export default CorporateSidebar;
// // import React from "react";
// // import { Link, useLocation } from "react-router-dom";

// // const CorporateSidebar = () => {
// //   const location = useLocation();

// //   const links = [
// //     { path: "/kurumsal/misyonumuz", label: "Misyonumuz" },
// //     { path: "/kurumsal/vizyonumuz", label: "Vizyonumuz" },
// //     { path: "/kurumsal/kalite-politikasi", label: "Kalite Politikamız" },
// //     { path: "/kurumsal/degerlerimiz", label: "Değerlerimiz" },
// //   ];

// //   return (
// //     <div className="space-y-3 bg-black p-4 rounded-md">
// //       {links.map((link) => (
// //         <Link
// //           key={link.path}
// //           to={link.path}
// //           className={`block p-2 rounded hover:bg-gray-700 ${
// //             location.pathname === link.path ? "font-bold text-white" : "text-gray-300"
// //           }`}
// //         >
// //           {link.label}
// //         </Link>
// //       ))}
// //     </div>
// //   );
// // };

// // export default CorporateSidebar;


// import React from "react";
// import { Link, useLocation } from "react-router-dom";

// const CorporateSidebar = () => {
//   const location = useLocation();

//   const links = [
//     { path: "/kurumsal/misyonumuz", label: "Misyonumuz" },
//     { path: "/kurumsal/vizyonumuz", label: "Vizyonumuz" },
//     { path: "/kurumsal/kalite-politikasi", label: "Kalite Politikamız" },
//     { path: "/kurumsal/degerlerimiz", label: "Değerlerimiz" },
//   ];

//   return (
//     <div className="w-64 bg-black p-4 rounded-md flex-shrink-0">
//       {links.map((link) => (
//         <Link
//           key={link.path}
//           to={link.path}
//           className={`block p-2 rounded hover:bg-gray-700 ${
//             location.pathname === link.path ? "font-bold text-white" : "text-gray-300"
//           }`}
//         >
//           {link.label}
//         </Link>
//       ))}
//     </div>
//   );
// };

// export default CorporateSidebar;
import React from "react";
import { Link, useLocation } from "react-router-dom";

const CorporateSidebar = () => {
  const location = useLocation();

  const links = [
    { path: "/kurumsal/misyonumuz", label: "Misyonumuz" },
    { path: "/kurumsal/vizyonumuz", label: "Vizyonumuz" },
    { path: "/kurumsal/kalite-politikasi", label: "Kalite Politikamız" },
    { path: "/kurumsal/degerlerimiz", label: "Değerlerimiz" },
  ];

  return (
    <div className="w-64 h-[30vh] bg-black p-6 rounded-md flex-shrink-0 mt-4 mb-4">
      {links.map((link) => (
        <Link
          key={link.path}
          to={link.path}
          className={`block p-3 rounded hover:bg-gray-700 ${
            location.pathname === link.path ? "font-bold text-white" : "text-gray-300"
          }`}
        >
          {link.label}
        </Link>
      ))}
    </div>
  );
};

export default CorporateSidebar;

